import resolve from 'ioc/resolve'
import prompt from 'webutils/address-input-prompt'

export default class AddressInfoController {
    constructor() {
        var $ctrl = this;
	}
	openPrompt() {
		var $ctrl = this;
		prompt.open({ model: $ctrl.address, key: $ctrl.key }).then(function (response) {
			$ctrl.address = response;
		});
	}
	$onInit() {
		const $ctrl = this;
		if (!$ctrl.hideAddressId) $ctrl.hideAddressId = false;
		if (!$ctrl.hidePhone) $ctrl.hidePhone = false;
		if (!$ctrl.hideEmail) $ctrl.hideEmail = false;
		if ($ctrl.allowEdit == undefined) $ctrl.allowEdit = true;
	}
}
